import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import Header from "../../components/landingPage/Header";
import Footer from "../../components/landingPage/Footer";
import InputField from "../../components/b2b/InputField";
import {
  faAddressCard,
  faBuilding,
  faEnvelope,
  faPhone,
  faUser,
} from "@fortawesome/fontawesome-free-solid";

const initialState = {
  firstName: "",
  lastName: "",
  email: "",
  companyName: "",
  contactNumber: "",
  address: "",
};

const ContactUs = () => {
  const dispatch = useDispatch();
  const [newUser, setnewUser] = useState(initialState);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setnewUser({ ...newUser, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (
      newUser.firstName === "" ||
      newUser.lastName === "" ||
      newUser.email === "" ||
      newUser.contactNumber === "" ||
      newUser.message === ""
    ) {
      toast.error("Please fill all the fields");
    } else {
      dispatch({ type: "REGISTER_MAIL", payload: newUser });
      setnewUser({
        firstName: "",
        lastName: "",
        email: "",
        contactNumber: "",
        message: "",
      });
    }
  };
  return (
    <>
      <div>
        <Header className="static" />
        <div className="">
          <img
            src={require("../../assets/images/login_landing.jpg")}
            alt=""
            className="hidden sm:block sm:h-[70rem] md:h-[51rem] lg:h-[50rem] xl:h-[51rem] w-screen object-cover"
          />

          {/* ------------------------------------ FOR SCREEN BELOW 640px --------------------------------------- */}
          <div className="sm:transparent sm:hidden w-screen h-[63rem] object-cover"></div>
          {/* ------------------------------------ FOR SCREEN BELOW 640px --------------------------------------- */}

          <div className="bg-gradient-to-r from-[#121518] to-[#322d2d] w-full h-[63rem] sm:h-[70rem] md:h-[51rem] opacity-80 absolute top-0"></div>
          <div className="w-full absolute top-10">
            <div className="px-5 md:px-10 lg:px-44 xl:px-96 2xl:px-[25rem] text-left my-10 sm:my-16">
              <div className="bg-black rounded-lg p-6 sm:p-16 xl:p-10 opacity-80 shadow-md">
                <h2 className="text-2xl sm:text-4xl text-center text-slate-50 font-body">
                  Get In Touch!
                </h2>
                <div className="w-full mt-10">
                  {/* <div className='bg-white border border-slate-200 p-16 shadow-md rounded-xl w-3/4'> */}
                  <div className="w-full md:flex md:space-x-5 justify-between">
                    <div className="md:w-2/3">
                      <h2 className="text-lg lg:text-md font-normal text-slate-300 font-body">
                        Please give us your details or call us!
                      </h2>
                      <div className="border-slate-400 border rounded-md mt-3 w-full">
                        <InputField
                          isFontawesome={true}
                          fontawesomeIcon={faUser}
                          placeholder="First name"
                          id="firstName"
                          name="firstName"
                          type="text"
                          value={newUser.firstName}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="border-slate-400 border rounded-md mt-3 w-full">
                        <InputField
                          isFontawesome={true}
                          fontawesomeIcon={faUser}
                          placeholder="Last name"
                          id="lastName"
                          name="lastName"
                          type="text"
                          value={newUser.lastName}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="border-slate-400 border rounded-md mt-3 w-full">
                        <InputField
                          isFontawesome={true}
                          fontawesomeIcon={faPhone}
                          placeholder="Contact Number"
                          id="contactNumber"
                          name="contactNumber"
                          type="text"
                          value={newUser.contactNumber}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="border-slate-400 border rounded-md mt-3 w-full">
                        <InputField
                          isFontawesome={true}
                          fontawesomeIcon={faEnvelope}
                          placeholder="Email Address"
                          id="email"
                          name="email"
                          type="text"
                          value={newUser.email}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="border-slate-400 border rounded-md mt-3 w-full">
                        <InputField
                          isFontawesome={true}
                          fontawesomeIcon={faAddressCard}
                          placeholder="Message us"
                          id="message"
                          name="message"
                          type="textarea"
                          value={newUser.message}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="text-center mt-5">
                        <button className="bg-[#fb4156] text-white w-full py-3 rounded-md">
                          SEND
                        </button>
                      </div>
                    </div>
                    <div className="mt-3">
                      {/* <div>
                        <h2 className="text-lg font-normal text-slate-50 font-body">
                          Registered Office
                        </h2>
                        <h4 className="text-sm text-slate-300 font-body">
                          DRIVADO TRANSFERS PVT. LTD.
                          <br />
                          P-3, New C.I.T. Road, 4th Floor,
                          <br />
                          Kolkata - 700073, West Bengal, India.
                        </h4>
                      </div> */}
                      <div className="my-5">
                        <h2 className="text-lg font-normal text-slate-50 font-body">
                          Registered Office
                        </h2>
                        <h4 className="text-sm text-slate-300 font-body">
                          Merlin Infinite, <br />
                          Unit #506, DN-51, <br />
                          Street Number 11, DN Block, <br />
                          Sector V, Bidhannagar, Kolkata, <br />
                          West Bengal 700091, India.
                        </h4>
                      </div>
                      <div>
                        <h2 className="text-lg font-normal text-slate-50 font-body">
                          Support
                        </h2>
                        <h4 className="text-sm text-slate-300 font-body">
                          support@drivado.com
                          <br />
                          <br />
                          (IN)+91 33 4004 5904,
                          <br />
                          (IN)+91 33 4601 8734
                        </h4>
                        <h4 className="text-sm text-slate-300 font-body">
                          <br />
                          (GB)+44 20 3769 9669,
                          <br /> (US)+1 917 764 4544
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default ContactUs;
